<div class="navbar-content">
  <div *ngIf="isStaging" class="staging-indicator">STAGING</div>
  <img src="assets/img/logo_mark.svg" alt="Logo" class="navbar-logo">
  <button class="navbar-btn" [ngClass]="{'active': activeButton === 'users'}" (click)="setActiveButton('users')"
    (click)="navigateTo('/users')">
    Users
  </button>
  <button class="navbar-btn" [ngClass]="{'active': activeButton === 'transactions'}"
    (click)="setActiveButton('transactions')" (click)="navigateTo('/transactions')">
    Transactions
  </button>
  <button class="navbar-btn" [ngClass]="{'active': activeButton === 'debit-orders'}"
    (click)="setActiveButton('debit-orders')" (click)="navigateTo('/debit-orders')">
    Debit Orders
  </button>

  <div class="navbar-right">
    <div class="bell-icon">
      <i class="icon-bell"></i>
    </div>
    <div class="vertical-line"></div>
    <!-- User email and image -->
    <div class="user-info" (click)="navigateTo('/admin')">
      <span class="username">{{adminUser?.email}}</span>
      <img [src]="adminUser?.imageUrl" alt="User Image" class="user-image" />
    </div>
  </div>
</div>